var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "page-header position-relative",
    class: [_vm.currentPayload.style, _vm.currentPayload.style === 'primary' ? 'd-flex justify-content-center' : 'p-0', _vm.currentPayload.style === 'primary' && _vm.currentPayload.backgroundColor ? 'layout-with-background' : 'layout-without-background'],
    style: {
      'background-color': _vm.currentPayload.style === 'primary' && _vm.currentPayload.backgroundColor
    }
  }, [_vm.hasMedia ? _c('MediaAndOverlay', {
    attrs: {
      "video-mp4": _vm.currentPayload.videoMp4,
      "video-webm": _vm.currentPayload.videoWebm,
      "auto-play": "",
      "src": _vm.currentPayload.src,
      "srcsets": _vm.currentPayload.srcsets,
      "ratio-img": _vm.currentPayload.ratioImg,
      "has-overlay": _vm.currentPayload.gradient,
      "overlay-type": "gradient"
    }
  }) : _vm._e(), _vm._v(" "), _c('GlobalIntro', {
    staticClass: "temp-global-intro col-11 col-md-10",
    class: _vm.introStyle,
    style: {
      color: _vm.currentPayload.color
    },
    attrs: {
      "payload": _vm.payload
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };